module.exports = __webpack_public_path__ + "5fb2818c453617b03f6ca5a3d3d3fb23.png";